export default function IconDoorQLines(props) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 12h18"/><path d="M3 6v12"/><path d="M21 6v12"/><path d="M8 6v2M8 16v2M16 6v2M16 16v2"/>
    </svg>
  )
}
